module.exports = __webpack_public_path__ + "static/img/scan_code.3166ad3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scan_code.jpg
// module id = 29PP
// module chunks = 10